import config from 'config';
import { extractPlaceFromGeocodingResults } from 'utils/googleGeocoding';

const cityCache = {};
function getPlace(lat, lng) {
  lat = Number(lat);
  lng = Number(lng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return Promise.reject(new Error('Valid coordinates are required to get a place'));
  }

  lat = lat.toFixed(5);
  lng = lng.toFixed(5);

  if (cityCache[lat] && cityCache[lat][lng]) {
    return cityCache[lat][lng];
  }

  if (!cityCache[lat]) {
    cityCache[lat] = {};
  }

  cityCache[lat][lng] = fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=en&key=${config.googleMaps.apiKey}`
  )
    .then(r => {
      if (!r.ok) {
        throw new Error(`Google geocoding request failed with status ${r.status}`);
      }

      return r.json();
    })
    .then(json => {
      if (json.status && !['OK', 'ZERO_RESULTS'].includes(json.status)) {
        throw new Error(`Google geocoding failed with status ${json.status}`);
      }

      return extractPlaceFromGeocodingResults(json.results);
    })
    .catch(error => {
      delete cityCache[lat][lng];
      throw error;
    });

  return cityCache[lat][lng];
}

const actionsGoogle = {
  getPlace,
};

export default actionsGoogle;
